import { useState } from "react";
import DownloadPdfComponent from "../../../../../../components/DownloadPdfComponent/DownloadPdfComponent";
import { ImageTitle } from "../../../../../../components/styled-components";
import "./CategoryDetailViewImageComponent.scss";
import PropTypes from "prop-types";
import imgNotAvailible from '../../../../../../assests/img_not_availible.png';
import ModalComponent from "../../../../../../components/ModalComponent/ModalComponent";
import globals from "../../../../../../config/appconfig";



/**
 * @function CategoryDetailViewImageComponent component that renders an image with the description, the button to expand and the download pdf
 * @returns {JSX.Element}
 */
const CategoryDetailViewImageComponent = ( { title, src, alt, allegato } ) => {
    const dowloadPdf = () => {
        window.open( `${ globals[ "app-url-bucket" ] }${ allegato }` );
    }
    const imgName = src.replace(/\D/gm, "");
    const idModal = "modaleImmagine" + imgName;
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <div className="CategoryDetailViewImageComponent">
                <div className="d-lg-flex justify-content-between flex-column flex-md-row mb-4">
                    <div className="align-self-md-center mb-2 my-lg-0" role="contentinfo" tabIndex="0" aria-label={title}>
                        <ImageTitle>{title}</ImageTitle>
                    </div>
                    <div className="align-self-md-center">
                        <div className="d-flex align vertical center">
                            <div className="CategoryDetailViewImageComponent__ZoomOutMap mx-lg-5 d-none d-lg-flex" type="button" onClick={() => setOpenModal(true)}>
                                <span className="material-icons-outlined CategoryDetailViewImageComponent__zoomButton" role="contentinfo" tabIndex="0" aria-label={"zoom"}>zoom_out_map</span>
                            </div>
                            <DownloadPdfComponent classBtn={ `${ !(allegato) ? "primary disabled" : "primary" }` } actionBtn={ () => dowloadPdf() } pdf={ false }></DownloadPdfComponent>
                        </div>
                    </div>
                </div>
                <div className="col-12" role="contentinfo" tabIndex="0">
                    <img
                        src={`${globals["app-url-bucket"]}${src}`}
                        title={title}
                        alt={alt}
                        width={"100%"}
                    />
                </div>
            </div>

            {openModal && <ModalComponent setOpenModal={() => setOpenModal(false) }  openModal={openModal}  allegato={allegato} idModale= { idModal } actionBtn={ () => dowloadPdf() } src={ src } title={ title } alt={ alt }></ModalComponent>}
        </>

    );
};

CategoryDetailViewImageComponent.propTypes = {
    title: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string
};

CategoryDetailViewImageComponent.defaultProps = {
    title: "Assistiti con scompenso cardiaco (figura 3.5.1)",
    src: imgNotAvailible,
    alt: "Figura 3.5.1"
};

export default CategoryDetailViewImageComponent;